import React from 'react';
import { Link } from 'react-router-dom';

export default function PoliticaPrivacidad() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
          
            <div>
              <h1 className="text-xl font-bold text-gray-800">Política de Privacidad</h1>
              <p className="text-xs text-gray-500">Sistema de Gestión de Fichajes</p>
            </div>
          </div>
          <Link 
            to="/" 
            className="flex items-center gap-2 bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-900 transition font-medium"
          >
            <i className="fas fa-arrow-left"></i>
            <span className="hidden sm:inline">Volver</span>
          </Link>
        </div>
      </header>

      {/* Contenido */}
      <main className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-8">
        {/* Info actualización */}
        <div className="bg-gray-100 border border-gray-200 rounded-lg p-4 mb-6">
          <div className="flex items-center gap-2 text-sm text-gray-700">
            <i className="fas fa-calendar-alt"></i>
            <span>Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
          </div>
        </div>

        {/* Contenido principal */}
        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 md:p-8 space-y-8 text-gray-700">
            {/* Introducción */}
            <section>
              <p className="leading-relaxed">
                Esta política expresa cómo se tratará y protegerá la información personal de todas las personas 
                que utilizan este sistema de gestión de fichajes laborales. Por favor, debes leer todos los apartados 
                de esta Política de Privacidad antes de utilizar esta aplicación.
              </p>
              <p className="mt-3 leading-relaxed">
                De conformidad con lo dispuesto en el Reglamento UE 2016/679, del Parlamento Europeo y del Consejo 
                del 27 de abril de 2016 (RGPD) y la Ley Orgánica 3/2018, del 5 de diciembre, de protección de Datos 
                Personales y garantía de los derechos digitales, FAECA Granada te informa de que, mediante la aceptación 
                de esta Política de Privacidad, prestas tu consentimiento expreso, informado, libre e inequívoco para que 
                los datos que proporcionas sean tratados por FAECA Granada, como responsable del tratamiento.
              </p>
            </section>

            {/* Responsable */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-user-shield text-gray-600"></i>
                ¿Quién es el responsable del tratamiento?
              </h2>
              <div className="bg-gray-50 border border-gray-200 p-5 rounded-lg space-y-2">
                <p><strong className="text-gray-700">Identidad del responsable:</strong> FAECA Granada</p>
                <p><strong className="text-gray-700">NIF/CIF:</strong> G18559419</p>
                <p><strong className="text-gray-700">Dirección:</strong> Calle Doctor López Font, Edif. Guadalquivir, Bajo 7, CP 18004 Granada</p>
                <p><strong className="text-gray-700">Correo electrónico:</strong> juridico@cooperativasgranada.com</p>
                <p><strong className="text-gray-700">Teléfono:</strong> 958522616</p>
              </div>
            </section>

            {/* Sección 1 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-database text-gray-600"></i>
                1. ¿Qué datos personales se recogen?
              </h2>
              <p className="mb-3">
                Para las finalidades establecidas en esta Política de Privacidad, FAECA Granada recaba y trata 
                los datos personales que se detallan a continuación:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Datos identificativos:</strong> nombre, apellidos, correo electrónico</li>
                <li><strong>Datos laborales:</strong> empresa asociada, rol (trabajador, administrador, administrador global), estado de habilitación</li>
                <li><strong>Datos de fichaje:</strong> fecha y hora de entrada/salida</li>
                <li><strong>Datos de sesión:</strong> token de autenticación JWT almacenado localmente en el navegador</li>
                <li><strong>Archivos multimedia:</strong> foto de perfil de usuario y logo de empresa (opcional)</li>
                <li><strong>Datos de navegación:</strong> dirección IP, tipo de dispositivo, tipo de navegador (almacenados temporalmente)</li>
              </ul>
            </section>

            {/* Sección 2 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-gavel text-gray-600"></i>
                2. ¿Con qué base legal se tratan esos datos?
              </h2>
              <p className="mb-3">Tratamos tus datos personales con las siguientes bases legales:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Ejecución de una relación laboral:</strong> Para la gestión del sistema de fichajes y control horario, conforme a la obligación legal establecida en el Real Decreto-ley 8/2019 de registro de jornada laboral</li>
                <li><strong>Consentimiento del usuario:</strong> Para el uso del sistema, la creación de cuenta y el procesamiento de datos personales</li>
                <li><strong>Obligación legal:</strong> Cumplimiento de normativa laboral vigente en materia de registro de jornada</li>
                <li><strong>Interés legítimo:</strong> Proteger a los usuarios de abusos, fraudes y garantizar la seguridad del sistema</li>
              </ul>
            </section>

            {/* Sección 3 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-bullseye text-gray-600"></i>
                3. ¿Con qué finalidades trataremos tus datos?
              </h2>
              <p className="mb-3">Los datos personales facilitados se utilizarán para:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Gestión de fichajes:</strong> Registrar y almacenar las horas de entrada y salida de los trabajadores</li>
                <li><strong>Autenticación:</strong> Verificar la identidad del usuario y mantener sesiones seguras mediante tokens JWT</li>
                <li><strong>Gestión de usuarios:</strong> Crear, editar y administrar cuentas de usuarios por parte de los administradores</li>
                <li><strong>Generación de reportes:</strong> Permitir a los administradores exportar datos de fichajes y generar informes laborales</li>
                <li><strong>Gestión de empresas:</strong> Administrar información de las empresas y su relación con los trabajadores</li>
                <li><strong>Mejora del servicio:</strong> Optimizar la funcionalidad y seguridad del sistema</li>
              </ul>
            </section>

            {/* Sección 4 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-clock text-gray-600"></i>
                4. Tiempo de conservación de los datos personales
              </h2>
              <p className="mb-3">
                Los datos personales facilitados se conservarán durante el menor tiempo posible teniendo en cuenta 
                los motivos por los que se necesita el tratamiento de los datos, así como las obligaciones legales 
                de conservar los datos durante un tiempo determinado.
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Datos de fichaje:</strong> Se conservan durante 4 años conforme a la legislación laboral y tributaria vigente</li>
                <li><strong>Datos de usuario:</strong> Se conservan mientras el usuario esté activo en el sistema o mientras exista relación laboral</li>
                <li><strong>Datos de sesión (tokens):</strong> Se eliminan automáticamente al cerrar sesión o cuando el token expira</li>
              </ul>
              <p className="mt-3">
                Posteriormente, los datos serán suprimidos conforme a lo dispuesto en la normativa de protección de datos, 
                lo que implica su bloqueo, estando disponibles tan sólo a solicitud de Jueces y Tribunales, el Ministerio 
                Fiscal o las Administraciones Públicas competentes durante el plazo de prescripción de las acciones que 
                pudieran derivar y, transcurrido éste, serán eliminados por completo.
              </p>
            </section>

            {/* Sección 5 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-cookie-bite text-gray-600"></i>
                5. Uso de cookies y almacenamiento local
              </h2>
              <p className="mb-3">
                Esta aplicación utiliza únicamente <strong>cookies esenciales y almacenamiento local (localStorage)</strong> 
                necesarias para el funcionamiento del sistema:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Token de autenticación:</strong> Almacenado en localStorage para mantener la sesión activa del usuario</li>
                <li><strong>Datos básicos del usuario:</strong> Información mínima necesaria para el funcionamiento de la interfaz</li>
                <li><strong>Preferencia de cookies:</strong> Registro de aceptación del banner de cookies</li>
              </ul>
              <p className="mt-3"><strong>No se utilizan:</strong></p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Cookies de terceros</li>
                <li>Cookies de seguimiento o analíticas</li>
                <li>Cookies publicitarias</li>
                <li>Herramientas de análisis externas (Google Analytics u otras)</li>
              </ul>
            </section>

            {/* Sección 6 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-lock text-gray-600"></i>
                6. Seguridad de los datos
              </h2>
              <p className="mb-3">
                FAECA Granada se compromete al uso y tratamiento de los datos personales del usuario, respetando su 
                confidencialidad y adoptando todas las medidas técnicas y organizativas necesarias:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Los datos se almacenan en una base de datos MongoDB con medidas de seguridad apropiadas</li>
                <li>Las contraseñas se hashean utilizando bcrypt (nunca se almacenan en texto plano)</li>
                <li>La comunicación se realiza mediante HTTPS (SSL/TLS) con certificado válido</li>
                <li>Los tokens de sesión tienen tiempo de expiración y deben renovarse periódicamente</li>
                <li>Solo el personal autorizado (administradores) tiene acceso a los datos según su rol</li>
                <li>Se implementan controles de acceso basados en roles (trabajador, administrador de empresa, administrador global)</li>
              </ul>
              <p className="mt-3">
                No obstante, FAECA Granada no puede garantizar la absoluta inexpugnabilidad de Internet ni, 
                por tanto, la violación de los datos mediante accesos fraudulentos a ellos por parte de terceros.
              </p>
            </section>

            {/* Sección 7 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-share-alt text-gray-600"></i>
                7. ¿A qué destinatarios se comunicarán tus datos?
              </h2>
              <p className="mb-3">
                Para la realización de determinadas tareas estrictamente necesarias para el desarrollo de la actividad, 
                FAECA Granada puede compartir datos con distintos proveedores de servicios externos:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Empresa de hosting y almacenamiento de servidores</li>
                <li>Servicios de mantenimiento y desarrollo web</li>
              </ul>
              <p className="mt-3">
                Todas ellas tendrán firmado un contrato de prestación de servicios que les obliga a mantener el 
                mismo nivel de privacidad que se aplica a los tratamientos realizados en esta aplicación conforme 
                a la normativa de protección de datos vigente.
              </p>
              <p className="mt-3">
                <strong>No se comparten, venden ni transfieren</strong> datos personales a terceros con fines comerciales 
                o publicitarios, excepto cuando sea legalmente requerido por autoridades competentes o para cumplir con 
                obligaciones legales (ej: inspecciones laborales).
              </p>
            </section>

            {/* Sección 8 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-user-check text-gray-600"></i>
                8. ¿Cuáles son tus derechos (RGPD)?
              </h2>
              <p className="mb-3">
                Cualquier persona tiene derecho a obtener confirmación sobre si en FAECA Granada estamos tratando 
                datos personales que le conciernen o no. Las personas interesadas tienen derecho a:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Acceso:</strong> Solicitar una copia de tus datos personales</li>
                <li><strong>Rectificación:</strong> Corregir datos inexactos o incompletos</li>
                <li><strong>Supresión:</strong> Solicitar la eliminación de tus datos (derecho al olvido), salvo que exista obligación legal de conservarlos</li>
                <li><strong>Portabilidad:</strong> Obtener tus datos en formato estructurado y comúnmente utilizado</li>
                <li><strong>Oposición:</strong> Oponerte al tratamiento de tus datos en determinadas circunstancias</li>
                <li><strong>Limitación:</strong> Solicitar la limitación del tratamiento de tus datos</li>
              </ul>
              <p className="mt-3">
                Si has otorgado tu consentimiento para alguna finalidad concreta, tienes derecho a retirar el 
                consentimiento otorgado en cualquier momento, sin que ello afecte a la licitud del tratamiento 
                basado en el consentimiento previo a su retirada.
              </p>
              <p className="mt-3">
                Para ejercitar estos derechos, puedes contactar con tu administrador de empresa o directamente 
                escribir a <strong>juridico@cooperativasgranada.com</strong> o presentar una comunicación en 
                Calle Doctor López Font, Edif. Guadalquivir, Bajo 7, CP 18004 Granada.
              </p>
              <p className="mt-3">
                Será necesario aportar fotocopia del DNI o documento equivalente que acredite tu identidad. 
                En caso de actuar mediante representación legal, deberás aportar también documento acreditativo 
                de la representación.
              </p>
              <p className="mt-3">
                En caso de que sientas vulnerados tus derechos en lo concerniente a la protección de tus datos 
                personales, especialmente cuando no hayas obtenido satisfacción en el ejercicio de tus derechos, 
                puedes presentar una reclamación ante la <strong>Agencia Española de Protección de Datos (AEPD)</strong>.
              </p>
            </section>

            {/* Sección 9 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-exclamation-triangle text-gray-600"></i>
                9. Notificación de brechas de seguridad
              </h2>
              <p className="mb-3">
                En FAECA Granada asumimos medidas de seguridad adecuadas al nivel de riesgo para proteger la 
                información personal contra la pérdida, el uso indebido y el acceso no autorizado, su divulgación, 
                alteración y destrucción.
              </p>
              <p>
                No obstante, si FAECA Granada determina que los datos personales han sido malversados, se han visto 
                expuestos por una brecha de seguridad o adquiridos de forma incorrecta por un tercero, actuará de 
                forma inmediata teniendo en cuenta lo establecido por el RGPD, notificando a la autoridad de control 
                competente en un plazo máximo de 72 horas y, cuando proceda, a los interesados afectados.
              </p>
            </section>

            {/* Sección 10 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-check-circle text-gray-600"></i>
                10. Exactitud y veracidad de los datos
              </h2>
              <p>
                Como usuario, eres el único responsable de la veracidad y corrección de los datos que facilites, 
                exonerando a FAECA Granada de cualquier responsabilidad al respecto. Los usuarios garantizan y 
                responden, en cualquier caso, de la exactitud, vigencia y autenticidad de los datos personales 
                facilitados, y se comprometen a mantenerlos debidamente actualizados.
              </p>
            </section>

            {/* Sección 11 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-users text-gray-600"></i>
                11. Datos personales de terceros
              </h2>
              <p>
                En el caso de que los datos personales aportados por un administrador pertenecieran a un tercero 
                (por ejemplo, al dar de alta a un trabajador), el administrador garantiza que ha informado a dicho 
                tercero de esta Política de Privacidad y ha obtenido su autorización para facilitar sus datos a 
                FAECA Granada con las finalidades señaladas.
              </p>
            </section>

            {/* Sección 12 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-child text-gray-600"></i>
                12. Menores de edad
              </h2>
              <p>
                Este sistema está diseñado para uso laboral y <strong>no está destinado a menores de 16 años</strong>. 
                No se recopila intencionadamente información de menores de edad.
              </p>
            </section>

            {/* Sección 13 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-sync-alt text-gray-600"></i>
                13. Cambios en esta política
              </h2>
              <p>
                FAECA Granada se reserva el derecho a modificar la presente política para adaptarla a novedades 
                legislativas o jurisprudenciales, así como a prácticas de la industria. En dichos supuestos, se 
                anunciará en esta página los cambios introducidos con razonable antelación a su puesta en práctica. 
                La fecha de última actualización se muestra en la parte superior de este documento.
              </p>
            </section>

            {/* Sección 14 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
                <i className="fas fa-envelope text-gray-600"></i>
                14. Información adicional y contacto
              </h2>
              <p className="mb-3">
                Si necesitas información adicional sobre protección de datos o tienes preguntas sobre esta política 
                de privacidad, puedes contactar con:
              </p>
              <div className="bg-gray-50 border border-gray-200 p-5 rounded-lg space-y-2">
                <p><strong className="text-gray-700">Responsable del tratamiento:</strong> FAECA Granada</p>
                <p><strong className="text-gray-700">NIF/CIF:</strong> G18559419</p>
                <p><strong className="text-gray-700">Email:</strong> juridico@cooperativasgranada.com</p>
                <p><strong className="text-gray-700">Dirección:</strong> Calle Doctor López Font, Edif. Guadalquivir, Bajo 7, CP 18004 Granada</p>
                <p><strong className="text-gray-700">Teléfono:</strong> 958522616</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-8">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
          <div className="text-center text-sm text-gray-500">
            <p>© {new Date().getFullYear()} FAECA Granada. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
  